import { CARRIER_NAMES, EXPERIENCE_NAMES } from '../../templates/components/checkout/constants';
import {
  FulfilmentCashOrCollectOption,
  FulfilmentNonDeliveryResponse,
  FulfilmentPresentation,
} from '@jbhi-fi/apis/src/fulfilment/types';

export enum OptionNames {
  Delivery = 'Delivery',
  ClickAndCollect = 'ClickAndCollect',
  CashAndCarry = 'CashAndCarry',
}

export const getNonDeliveryOptions = (
  response: FulfilmentNonDeliveryResponse,
  optionName: keyof typeof OptionNames
): Array<FulfilmentCashOrCollectOption> => {
  switch (optionName) {
    case 'CashAndCarry':
      return response?.cashAndCarryOptions ?? [];
    case 'ClickAndCollect':
      return response.clickAndCollectOptions ?? [];
    default:
      return [];
  }
};

export const sortDeliveryPresentations = (
  deliveryPres: Array<FulfilmentPresentation>
): Array<FulfilmentPresentation> => {
  const cheapest = [];
  const fastest = [];
  const rest = [];

  deliveryPres?.forEach(element => {
    if (element.tags?.includes('Cheapest')) {
      cheapest.push(element);
    } else if (element.tags?.includes('Fastest')) {
      fastest.push(element);
    } else {
      rest.push(element);
    }
  });

  // sort the delivery options other than Cheapest and Fastest based on price
  rest.sort((a: FulfilmentPresentation, b: FulfilmentPresentation) => {
    return a.price - b.price;
  });

  const sortedDeliveryPresentations = [...cheapest, ...fastest, ...rest];
  const containsAsapDeliveryOption = sortedDeliveryPresentations.some(
    s => s.carrier?.name === CARRIER_NAMES.uber && s.experienceName === EXPERIENCE_NAMES.asap
  );

  return containsAsapDeliveryOption
    ? sortedDeliveryPresentations.filter(s => s.experienceName !== EXPERIENCE_NAMES.scheduled)
    : sortedDeliveryPresentations;
};
